import { render, staticRenderFns } from "./RateStep.vue?vue&type=template&id=489836b6&scoped=true&lang=html&"
import script from "./RateStep.vue?vue&type=script&lang=js&"
export * from "./RateStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489836b6",
  null
  
)

export default component.exports